// extracted by mini-css-extract-plugin
module.exports = {"social-media-buttons":"SignInForm_social-media-buttons__n4zkl"};